
export default {
    createEvent(name, props){
        dataLayer.push({
            'event': name,
            ...props
        });
    },
    createVirtualPageView(props){
        dataLayer.push({
            'event': 'virtualPageView',
            ...props
        });

    }
}